const environmentDomain = window.location.origin;

const config = () => {
  if (
    environmentDomain === "https://adminnewtest.akead.net" ||
    environmentDomain === "http://localhost:3000" ||
    environmentDomain === "https://admintest.akead.net"
  ) {
    return {
      VERSION: "1.0.7",
      NAME: "AKEAD-TEST",
      API_URL: "https://authenticationtest.akead.link",
      PARTNER_URL: "https://partnertest.akead.xyz",
      PARTNER_URL_LIVE: "https://partner.akead.link",
      HELP_URL: "https://apigatetest.akead.xyz/help",
      CODE: "200",
      //   CONNECTION_CODE: "PARTNER",
      CHIPER_KEY: "125%44.6",
      LIVE_CHIPER_KEY: "7.Qu2Wv%",
      LIST_URL: "https://apigatetest.akead.xyz/lst"
    };
  }

  if (environmentDomain === "https://admin.akead.net") {
    return {
      VERSION: "1.0.7",
      NAME: "AKEAD-PROD",
      API_URL: "https://authentication.akead.link",
      PARTNER_URL: "https://partner.akead.link",
      PARTNER_URL_LIVE: "https://partner.akead.link",
      HELP_URL: "https://help.akead.link",
      CODE: "200",
      //   CONNECTION_CODE: "PARTNER",
      CHIPER_KEY: "7.Qu2Wv%",
      LIVE_CHIPER_KEY: "7.Qu2Wv%",
      LIST_URL: "https://apigate.akead.link/lst"
    };
  }

  console.error("Environment domain unknown:", environmentDomain);
  throw new Error("Geçersiz domain: config() için eşleşen ortam bulunamadı.");
};

export default config;



